export const phoneRegex = /^[0-9]{3} [0-9]{3,4} [0-9]{4}/;
export const numberRegex = /^\d+$/;
export const ssnRegex = /^(?:[0-9]{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[1,2][0-9]|3[0,1]))[1-8][0-9]{6}$/;
export const passwordRegex = /^[*#]*\d*[*#]*$/;
